export enum DisplayTypeEnum {
    Notification = 'Notification',
    Screen = 'Screen',
}
